/** enforces maxChars on input-components that supports it. */
const enforceMaxChars = true;

export { enforceMaxChars };
